import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
function Menu() {

  const { t, i18n } = useTranslation();
  return (
    <footer className="footer pt-60">
      <div className="container">
        <div className="footer-about">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div className="footer-logo mb-15"></div>
              <p>{t('Footer_description')}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 offset-lg-2">

              <ul className="footer-contact list-inline">
                <li className="list-inline-item">{t('Footer_coordo')}<a href="mailto:tgarcia@lfitokyo.org"><i className="far fa-envelope"></i>tgarcia@lfitokyo.org</a></li>
           
                <p>&copy;{t('Footer_droits')}</p>

              </ul>

            </div>
          </div>
        </div>
      </div>

    </footer>
  );

}

export default Menu;